import React from 'react';

/**
 * GridSaveLayoutButton — Renders a "Save layout" button that triggers
 * useGridLayout's saveLayout (with built-in overwrite warning in the hook).
 *
 * @param {object} props
 * @param {function} props.onSave - The saveLayout function from useGridLayout
 * @param {string} [props.label] - Button label (default: "Save layout")
 * @param {object} [props.style] - Additional inline styles
 * @param {string} [props.className] - Additional CSS class
 */
export default function GridSaveLayoutButton({ onSave, label = 'Save layout', style, className }) {
  return (
    <button
      type="button"
      onClick={onSave}
      className={className}
      style={{
        padding: '0.3rem 0.6rem',
        fontSize: '12px',
        cursor: 'pointer',
        ...style,
      }}
      title="Save current grid column layout"
    >
      {label}
    </button>
  );
}
